import { authApi } from "../../utils/axios";

/**
 * POST /auth/user-stripe-connect
 * Creates (if needed) the user's Stripe Express connected account and
 * returns an account-onboarding link.
 *
 * @param {{ refreshURL: string, returnURL: string }} body
 * @returns {Promise<{ url: string, expires_at: number, object: string, created: number }>}
 */
export const initiateUserStripeConnect = async ({ refreshURL, returnURL }) => {
  const { data } = await authApi.post("auth/user-stripe-connect", {
    refreshURL,
    returnURL,
  });
  return data;
};

/**
 * POST /auth/user-stripe-connect/verify
 * Asks the backend to confirm with Stripe whether the user has fully completed
 * onboarding. On success, the backend updates user.stripe.connectedAccount.
 *
 * @returns {Promise<object>} updated user.stripe object
 */
export const verifyUserStripeConnect = async () => {
  const { data } = await authApi.post("auth/user-stripe-connect/verify");
  return data;
};
